import { useCallback, useMemo, type ReactNode } from "react";
import "./AccountDropdown.scss";
import { Dropdown, type DropdownSelectionType } from "@repo/ping-design";

export type AccountOption = {
  id: string;
  label: ReactNode;
  value: string;
  onClick: () => void;
};

type AccountDropdownProps = {
  name?: string;
  account_options: AccountOption[];
};

const AccountDropdown = ({ name, account_options }: AccountDropdownProps) => {

  const dropdownOptions = useMemo(
    () => account_options.map(({ id, label, value }) => ({ id, label, value })),
    [account_options],
  );

  const handleChange = useCallback(
    (selection: { type: DropdownSelectionType.SimpleValue; value: string }) => {
      const option = account_options.find(
        (opt) => opt.value === selection.value,
      );
      option?.onClick();
    },
    [account_options],
  );

  return name ? (
    <Dropdown
      customTrigger={
        <div className="AccountDropdown__Avatar">{name}</div>
      }
      options={dropdownOptions}
      variant="default"
      orientation="down"
      offsetX={10}
      offsetY={12}
      selected={dropdownOptions[0]?.value}
      onChange={handleChange}
      dropdownWidth="max-content"
      menuItemClasses="AccountDropdown__Item"
    />
  ) : null;
};

export default AccountDropdown;
